import { Datatype, PlainDatatypes } from '../../../datatype/Datatype';
import { createConditionOperator } from '../IConditionOperator';

export const ConditionOperatorDefinedType = createConditionOperator({
  code: 'defined',
  label: 'definito',
  description: 'Definito',
  args: [],
  allowsField: field =>
    PlainDatatypes.includes(field.type) || field.type === Datatype.File,
  compare(value: any) {
    return value != null;
  },
});
